import React, { Component } from 'react'
import intl from '@alife/react-intl-universal';
// import intl from '../../lib/index';

class BasicComponent extends Component {
  render () {
    return (
      <div>
        <div className="title">Basic Examples:</div>
        <div>{intl.get('SIMPLE')}</div>
        <div>{intl.get('HELLO', {name:'Tony', where:'Alibaba'})}</div>
      </div>
    )
  }
}

export default BasicComponent;


// WEBPACK FOOTER //
// ./src/Basic.js